@if(item.navCap) {
  <div mat-subheader class="nav-caption">
    {{ item.navCap }}
  </div>
} 
@if(!item.navCap && !item.external && !item.twoLines) {
    <a 
    mat-list-item 
    (click)="onItemSelected(item)" 
    style="cursor: pointer;"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': isRouteActive(item)
    }"
    class="menu-list-item">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName }}</span>
  </a>
}
